import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import HeaderThin from 'app/components/layout/HeaderThin';
import CompetitionsTable from 'app/components/competitions/CompetitionsTable';

import * as competitionActions from 'app/ducks/competitions/actions';
import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as competitionSelectors from 'app/ducks/competitions/selectors';
import * as organisationSelectors from 'app/ducks/organisations/selectors';

interface ICompetitionsList {
  actions: any;
  organisations: any;
  organisationTags: any;
  competitions: any;
  groups: any;
  appReady: boolean;
}
const selector = (state): any => ({
  competitions: competitionSelectors.getCompetitions(state),
  organisations: organisationSelectors.getOrganisations(state),
  appReady: loadingSelectors.appReady(state),
});

const actionCreators = _.merge(competitionActions);

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class CompetitionsList extends React.Component<
  ICompetitionsList
> {
  static defaultProps: ICompetitionsList = {
    actions: undefined,
    organisations: undefined,
    organisationTags: undefined,
    competitions: {},
    groups: undefined,
    appReady: false,
  };

  componentDidMount = (): void => {
    this.props.actions.getAllCompetitions();
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Competitions"
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <CompetitionsTable
              {...this.props}
              {...this.props.competitions}
              selectCompetition={this.props.actions.selectCompetition}
            />
          </div>
        </div>
      </div>
    );
  }
}
